import { TimeBucket, TimeBucket_TimeSeries } from "../proto/generated/common";
import { SuperChartConfiguration_TimeBucket } from "../proto/generated/superchart-page";
import { calculateGcd } from "./orders";

export const isIntraday = (timeSeries: TimeBucket_TimeSeries) => {
    return [TimeBucket_TimeSeries.SECOND, TimeBucket_TimeSeries.MINUTE, TimeBucket_TimeSeries.HOUR].includes(timeSeries)
}

export const getTimeBucketDisplayName = (timeBucket: TimeBucket) => {
    switch (timeBucket.timeSeries) {
        case TimeBucket_TimeSeries.SECOND:
            return timeBucket.value.toString().concat('s')
        case TimeBucket_TimeSeries.MINUTE:
            return timeBucket.value.toString().concat('m')
        case TimeBucket_TimeSeries.HOUR:
            return timeBucket.value.toString().concat('h')
        case TimeBucket_TimeSeries.DAY:
            return timeBucket.value.toString().concat('D')
        case TimeBucket_TimeSeries.WEEK:
            return timeBucket.value.toString().concat('W')
        case TimeBucket_TimeSeries.MONTH:
            return timeBucket.value.toString().concat('M')
        case TimeBucket_TimeSeries.YEAR:
            return timeBucket.value.toString().concat('Y')
    }
}

export const convertToTimeBucket = (timeBucket: SuperChartConfiguration_TimeBucket): TimeBucket => {
    return {
        timeSeries: timeBucket.timeSeries,
        value: timeBucket.timeValue
    }
}

export const getTimeBucketLengthInSeconds = (timeBucket: TimeBucket): number => {
    let duration = 0;
    switch (timeBucket.timeSeries) {
        case TimeBucket_TimeSeries.SECOND:
            duration = 1;
            break;
        case TimeBucket_TimeSeries.MINUTE:
            duration = 60;
            break;
        case TimeBucket_TimeSeries.HOUR:
            duration = 3600;
            break;
        case TimeBucket_TimeSeries.DAY:
            duration = 375 * 60
            break;
        case TimeBucket_TimeSeries.WEEK:
            duration = 5 * 375 * 60
            break;
        case TimeBucket_TimeSeries.MONTH:
            duration = 21 * 375 * 60
            break;
        case TimeBucket_TimeSeries.YEAR:
            duration = 252 * 375 * 60
            break;
    }
    return duration * timeBucket.value;

}

export const getTimeBucketsGCD = (timeBuckets: SuperChartConfiguration_TimeBucket[]): TimeBucket => {
    const intradayBucketDurations: number[] = [];
    const nonIntradayBucketDurations: number[] = [];

    timeBuckets.forEach((tb) => {
        if ([TimeBucket_TimeSeries.TIME_SERIES_UNKNOWN, TimeBucket_TimeSeries.UNRECOGNIZED].includes(tb.timeSeries)) return;
        if ([TimeBucket_TimeSeries.DAY, TimeBucket_TimeSeries.WEEK, TimeBucket_TimeSeries.MONTH, TimeBucket_TimeSeries.YEAR].includes(tb.timeSeries)) {
            let days = 0;
            switch (tb.timeSeries) {
                case TimeBucket_TimeSeries.DAY:
                    days = tb.timeValue;
                    break;
                case TimeBucket_TimeSeries.WEEK:
                    days = tb.timeValue * 5;
                    break;
                case TimeBucket_TimeSeries.MONTH:
                    days = tb.timeValue * 21;
                    break;
                case TimeBucket_TimeSeries.YEAR:
                    days = tb.timeValue * 252;
                    break;
            }
            nonIntradayBucketDurations.push(days);
        } else {
            intradayBucketDurations.push(
                getTimeBucketLengthInSeconds({ timeSeries: tb.timeSeries, value: tb.timeValue })
            );
        }
    });

    if (intradayBucketDurations.length) {
        const gcd = calculateGcd(intradayBucketDurations);
        if (gcd % 3600 === 0) {
            return {
                timeSeries: TimeBucket_TimeSeries.HOUR,
                value: gcd / 3600
            }
        }

        if (gcd % 60 === 0) {
            return {
                timeSeries: TimeBucket_TimeSeries.MINUTE,
                value: gcd / 60
            }
        }

        return {
            timeSeries: TimeBucket_TimeSeries.SECOND,
            value: gcd
        }
    } else if (nonIntradayBucketDurations.length) {
        const gcd = calculateGcd(nonIntradayBucketDurations);
        if (gcd % 252 === 0) {
            return {
                timeSeries: TimeBucket_TimeSeries.YEAR,
                value: gcd / 252
            };
        }

        if (gcd % 21 === 0) {
            return {
                timeSeries: TimeBucket_TimeSeries.MONTH,
                value: gcd / 21
            };
        }

        if (gcd % 5 === 0) {
            return {
                timeSeries: TimeBucket_TimeSeries.WEEK,
                value: gcd / 5
            };
        }
        return {
            timeSeries: TimeBucket_TimeSeries.DAY,
            value: gcd
        }
    }

    return {
        timeSeries: TimeBucket_TimeSeries.TIME_SERIES_UNKNOWN,
        value: 1
    }
}